import { evaluateCondition } from '@folio/components/forms/form-builder/conditionalVisibilityUtils';
import type { ClaimsReviewSection } from 'korint-sdk/react';
import _ from 'lodash';

type VisibleClaimsSection = Omit<ClaimsReviewSection, 'id' | 'showWhen'> & { id?: string };

/** No sections configured = a single untitled section listing every claim */
export function selectVisibleClaimsSections(
  sections: ClaimsReviewSection[] | undefined,
  comparedPolicies: object[],
): VisibleClaimsSection[] {
  if (!sections) return [{}];

  return sections.filter(
    ({ showWhen }) =>
      !showWhen?.length ||
      comparedPolicies.some(policy =>
        showWhen.every(condition =>
          evaluateCondition(condition, _.get(policy, condition.apiProperty)),
        ),
      ),
  );
}
